const PRODUCT_ID_MIN_LENGTH = 8

const normalizationPattern = /^d?(?<digits>\d+)$/iu

/**
 * transforms product id if necessary so it's understood across system uniformely.
 * - if starts with D. In this case we should remove leading D letter
 * - if id in url param length is less than 8, id is padded with leading zeros until minimum id length
 * @remark
 * legacy reasons, before a pzn was used, later on product started to be identified by upid,
 * some services rely on a constant length of product id, so we need to normalize it
 */
export const normalizeProductId = (id: string): string => {
  const match = normalizationPattern.exec(id)

  if (!match?.groups) {
    return id
  }

  return match.groups.digits.padStart(PRODUCT_ID_MIN_LENGTH, '0')
}
